<template>

    <div class="layout__container">

        <div class="layout__width-80 layout__padding-clear">

            <div class="text__align-center text__colour-white layout__margin__bottom-25px">
                <div class="layout__padding-clear layout__width-70 layout__padding-40px-0 layout__border__bottom-light-teal-1px">
                    <h2 class="text__colour-teal">Photofixr Order Details</h2>
                    <div class="layout__padding-20-0 text__size-18 text__colour-grey">Here you can see the details of
                        your photofixr order.
                    </div>
                </div>
            </div>

            <div class="layout__padding-clear">

                <div class="component__forms-3">
                    <div class="colour__background-light-grey layout__width-80 layout__padding-10px layout__position-left layout__border__radius-3">
                        <!--<span class="text__colour-teal"> Customer Details </span>-->
                        <div class="layout__cursor-pointer text__size-14 text__colour-teal layout__position-left layout__padding__right-20px"
                             v-on:click="customerInformation = !customerInformation">
                            <span v-if="this.customerInformation === false"
                                  class="icon-plus layout__padding__right-20px"></span>
                            <span v-if="this.customerInformation !== false"
                                  class="icon-minus layout__padding__right-20px"></span>
                            <span class="text__colour-teal"> Customer Details </span>
                        </div>
                    </div>
                    <div class="layout__position-left layout__width-100 layout__padding-5px"
                         v-show="this.customerInformation">
                        <p class="text_colour-909399">Contact Name</p>
                        <p>{{this.orderOverview.name}}</p>
                        <br>
                        <p class="text_colour-909399">Contact Email</p>
                        <p>{{this.orderOverview.email}}</p>
                        <br>
                        <p class="text_colour-909399">Branch Code</p>
                        <p>{{this.orderOverview.customerRef}}</p>
                        <br>
                        <p class="text_colour-909399">Account Type</p>
                        <p>
                            <span v-show="this.orderOverview.customerRef === 'PFCC1'">Online Customer</span>
                            <span v-show="this.orderOverview.customerRef !== 'PFCC1'">Account Customer</span>
                        </p>
                        <br>
                        <p class="text_colour-909399">Billing Address</p>
                        <p>{{this.customerDetails.address1}}</p>
                        <p>{{this.customerDetails.address2}}</p>
                        <p>{{this.customerDetails.address3}}</p>
                        <p>{{this.customerDetails.town}}</p>
                        <p>{{this.customerDetails.county}}</p>
                        <p>{{this.customerDetails.postcode}}</p>
                    </div>
                </div>
                <div class="component__forms-3">
                    <div class="colour__background-light-grey layout__width-80 layout__padding-10px layout__position-left layout__border__radius-3">
                        <!--<span class="text__colour-teal"> Customer Details </span>-->
                        <div class="layout__cursor-pointer text__size-14 text__colour-teal layout__position-left layout__padding__right-20px"
                             v-on:click="orderInformation = !orderInformation">
                            <span v-if="this.orderInformation === false"
                                  class="icon-plus layout__padding__right-20px"></span>
                            <span v-if="this.orderInformation !== false"
                                  class="icon-minus layout__padding__right-20px"></span>
                            <span class="text__colour-teal"> Order Details </span>
                        </div>
                    </div>
                    <div class="layout__position-left layout__width-100 layout__padding-5px"
                         v-show="this.orderInformation">
                        <p class="text_colour-909399">Order No</p>
                        <p>{{this.orderOverview.jobId}}</p>
                        <br>
                        <p class="text_colour-909399">Order Reference</p>
                        <p>{{this.orderOverview.jobName}}</p>
                        <br>
                        <p class="text_colour-909399">Status</p>
                        <p>{{this.orderOverview.status}}</p>
                        <br>
                        <p class="text_colour-909399">Date</p>
                        <p>{{formatDateDDMMYYYY(this.orderOverview)}}</p>
                    </div>
                </div>
                <div class="component__forms-3">
                    <div class="colour__background-light-grey layout__width-80 layout__padding-10px layout__position-left layout__border__radius-3">
                        <!--<span class="text__colour-teal"> Customer Details </span>-->
                        <div class="layout__cursor-pointer text__size-14 text__colour-teal layout__position-left layout__padding__right-20px"
                             v-on:click="paymentInformation = !paymentInformation">
                            <span v-if="this.paymentInformation === false"
                                  class="icon-plus layout__padding__right-20px"></span>
                            <span v-if="this.paymentInformation !== false"
                                  class="icon-minus layout__padding__right-20px"></span>
                            <span class="text__colour-teal"> Payment Details </span>
                        </div>
                    </div>
                    <div class="layout__position-left layout__width-100 layout__padding-5px"
                         v-show="this.paymentInformation">
                        <p class="text_colour-909399">Voucher Code</p>
                        <!--todo needs to be pulled from photofixr jobs-->
                        <p v-show="this.job.voucherUsed === 'PFBULK5PLUS'">Bulk Discount - 5</p>
                        <p v-show="this.job.voucherUsed === 'PFBULK10PLUS'">Bulk Discount - 10</p>
                        <p v-show="this.job.voucherUsed !== 'PFBULK5PLUS' && this.job.voucherUsed !== 'PFBULK10PLUS'">
                            {{this.job.voucherUsed}}</p>
                        <br>
                        <p class="text_colour-909399">Voucher Discount </p>
                        <p>£{{this.job.voucherValue}}</p>
                        <br>
                        <p class="text_colour-909399">Subtotal (ex. VAT)</p>
                        <p>£{{this.orderOverview.billNetTotal}}</p>
                        <br>
                        <p class="text_colour-909399">VAT</p>
                        <p>£{{this.orderOverview.billVatTotal}}</p>
                        <br>
                        <p class="text_colour-909399">Total (inc. VAT)</p>
                        <p>£{{this.orderOverview.billGrossTotal}}</p>
                    </div>
                </div>
            </div>


            <div class="layout__padding-clear layout__padding-20-0" v-show="this.role.includes('Customer')">
                <div class="layout__padding-clear text__align-center">
                    <el-button class="button-red layout__margin-20-0 layout__width-250px"
                               :disabled="this.orderOverview.despatched === null"
                               v-on:click="downloadCompleteOrders()">Download Completed Order
                    </el-button>
                </div>

                <el-table :data="job.orders" :default-sort="{prop: 'orderStatus', order: 'ascending'}">
                    <el-table-column prop="id" label="ID" width="100">
                    </el-table-column>
                    <el-table-column label="Image">
                        <template slot-scope="props" width="80">
                            <img class="layout__width-100" v-bind:src="props.row.leadImageUrlThumb"/>
                        </template>
                    </el-table-column>
                    <el-table-column label="Fixes" width="200">

                        <template slot-scope="props">
                            <div v-for="(task) in props.row.taskItems">
                                <p>{{ task.taskType }}</p>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="information" label="Additional Info" width="300">
                    </el-table-column>
                    <el-table-column prop="orderStatus" label="Status" sortable width="150">
                    </el-table-column>
                    <el-table-column label="Download Processed Photo(s)">
                        <template slot-scope="props">
                                <img class="layout__width-20px layout__position-center" v-show="props.row.despatched !== null"
                                     v-on:click="downloadOrderItem(props.row)"
                                    src="https://rpsassets.blob.core.windows.net/rpsimages/images/icons/download.png">

                                <img class="layout__width-20px layout__position-center" v-show="props.row.despatched === null"
                                     :disabled="true"
                                     v-on:click="stopPropagation" src="https://rpsassets.blob.core.windows.net/rpsimages/images/icons/download-null.png">
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div class="layout__padding-clear layout__padding-20-0" v-show="!(this.role.includes('Customer'))">
                <div class="layout__padding-clear text__align-center">
                    <el-button class="button-red layout__margin-20-0 layout__width-250px"
                               v-on:click="downloadJobBag()">Download Job Bag
                    </el-button>
                </div>

                <el-table :data="job.orders" :default-sort="{prop: 'orderStatus', order: 'ascending'}">
                    <el-table-column prop="id" label="ID" width="100">
                    </el-table-column>
                    <el-table-column label="Image">
                        <template slot-scope="props" width="80">
                            <img class="layout__width-100" v-bind:src="props.row.leadImageUrlThumb"/>
                        </template>
                    </el-table-column>
                    <el-table-column label="Fixes" width="150">

                        <template slot-scope="props">
                            <div v-for="(task) in props.row.taskItems">
                                <p>{{ task.taskType }}</p>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="information" label="Additional Info" width="300">
                    </el-table-column>
                    <el-table-column prop="orderStatus" label="Status" sortable width="100">
                    </el-table-column>
                    <el-table-column prop="" label="Comment">
                        <template slot-scope="props">
                            <h4 class="text__colour-teal" v-on:click="viewComments(props.row)">Order Comments</h4>
                        </template>
                    </el-table-column>
                    <el-table-column label="Download Unprocessed Photo(s)">
                        <template slot-scope="props">
                                <img v-on:click="downloadOrderBag(props.row)"
                                    class="layout__width-20px layout__position-center"
                                    src="https://rpsassets.blob.core.windows.net/rpsimages/images/icons/download.png">
                        </template>
                    </el-table-column>
                    <el-table-column label="Download Processed Photo(s)">
                        <template slot-scope="props">
                                <img v-show="props.row.despatched !== null"
                                     v-on:click="downloadOrderItem(props.row)"
                                    class="layout__width-20px layout__position-center"
                                    src="https://rpsassets.blob.core.windows.net/rpsimages/images/icons/download.png">
                                <img v-show="props.row.despatched === null"
                                     :disabled="true"
                                     v-on:click="stopPropagation"
                                    class="layout__width-20px layout__position-center"
                                    src="https://rpsassets.blob.core.windows.net/rpsimages/images/icons/download-null.png">
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <el-dialog
                    :visible="uploadComments"
                    :show-close="false">

                <div class="layout__position-center text__align-center">

                    <h3 class="text__align-center text__colour-teal">Conversation History</h3>

                    <div v-for="(comment) in this.conversationHistory">
                        <p> {{comment.message}}</p>
                    </div>

                    <h4 class="text__align-center text__colour-teal layout__margin__top-30">Add Comments to Order: </h4>
                    <el-input type="textarea" v-model="taskComments">

                    </el-input>

                    <div class="text__align-center layout__margin-20-0">
                        <el-button class="button-red button__base layout__margin__right-20px layout__width-200px"
                                   :disabled="taskComments === ''" v-on:click="addComments()">Update Comments
                        </el-button>
                        <el-button class="button-teal button__base layout__width-200px" v-on:click="uploadComments = false">Close
                        </el-button>
                    </div>

                </div>


            </el-dialog>

        </div>
    </div>


</template>

<script>

    import Axios from 'axios';
    import {axios} from '@/mixins/Axios.js';
    import {csvDownloadHelper} from '@/mixins/CsvDownloadHelper.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';

    export default {
        name: "JobDetails",
        mixins: [axios, csvDownloadHelper, dataFormatter],
        created() {

            this.id = this.$route.query.id
            console.log(this.id)
            // this.orderOverview = this.$route.query.orderOverview
            console.log(this.orderOverview)

            console.log(this.returnCookie("_role"))
            this.role = JSON.parse(this.returnCookie("_role"))


            if (typeof this.orderOverview === 'undefined') {
                if (window.sessionStorage.getItem('_photofixrOrder') !== null) {
                    this.orderOverview = JSON.parse(window.sessionStorage.getItem('_photofixrOrder'))

                    console.log(this.orderOverview)
                }
            }

            const url = `${process.env.VUE_APP_PHOTOFIXRAPIHOST}/api/v1/photofixr/jobs/` + this.id

            // todo this is only an example to get some data populated on screen it needs to be the uri above
            // const url = `${process.env.VUE_APP_PHOTOFIXRAPIHOST}/api/v1/photofixr/jobs/2573`
            console.log('printing the url from the job level create method ' + url)
            Axios.get(url, this.returnAcceptHeader())
                .then(response => {

                    console.log('photofixr order information')
                    console.log(response.data)
                    this.job = response.data

                    this.job.jobCreated = new Date(this.job.jobCreated).toLocaleDateString('en-GB')
                    this.job.jobWorkCompletedDate = new Date(this.job.jobWorkCompletedDate).toLocaleDateString('en-GB')


                    if (this.orderOverview.customerRef !== 'PFCC1') {
                        const customerUrl = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Customer/FindByRef?customerRef=` + this.orderOverview.customerRef
                        // const customerUrl = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Customer/FindByRef?customerRef=XXX1`
                        console.log(customerUrl)
                        Axios.get(customerUrl, this.returnHeaderUsingToken())
                            .then(response => {
                                this.customerDetails = response.data.result
                                console.log(response.data.result)
                                console.log('customerDetails ' + this.customerDetails)
                            })
                    }

                });

        },
        beforeUpdate() {
            window.sessionStorage.setItem('_photofixrOrder', JSON.stringify(this.orderOverview));
        },
        data() {
            return {
                job: {},
                orders: [],
                uploadComments: false,
                task: '',
                taskComments: '',
                taskStarted: '',
                taskStatus: '',
                uploadDialogVisible: false,
                orderUpload: {},
                order: '',
                key: '',
                role: [],
                conversationHistory: [],
                customerDetails: {},
                customerDialogVisible: false,
                customerDetails: {},
                authCookies: {},
                id: '',
                customerInformation: false,
                orderInformation: false,
                paymentInformation: false
            }
        },
        props: {
            orderOverview: {}
        },
        methods: {
            addComments() {
                const url = `${process.env.VUE_APP_PHOTOFIXRAPIHOST}/api/v1/photofixr/jobs/` + this.id + '/orders/' + this.order.id + '/conversations'

                const message = {
                    "id": 0,
                    "message": this.taskComments
                }


                Axios.post(url, message, this.returnContentHeader)
                    .then(response => {
                        console.log('response from comment post ' + response)

                        Axios.get(url, this.returnContentHeader)
                            .then(response => {
                                console.log('response from comment get ' + response)

                                this.conversationHistory = response.data
                            })
                    })

                // this.uploadComments = false
                this.taskComments = '';
            },
            viewComments(props) {

                this.order = props
                const url = `${process.env.VUE_APP_PHOTOFIXRAPIHOST}/api/v1/photofixr/jobs/` + this.id + '/orders/' + this.order.id + '/conversations'

                console.log(url)

                Axios.get(url, this.returnContentHeader)
                    .then(response => {
                        console.log('response from comment get ' + response)

                        this.conversationHistory = response.data
                    })
                this.uploadComments = true

            },
            downloadOrderBag(order) {
                const downloadOrderBag = `${process.env.VUE_APP_PHOTOFIXRAPIHOST}/api/v1/photofixr/jobs/` + this.id + '/orders/' + order.id + '/download'
                this.downloadLink(event, downloadOrderBag)
            },
            downloadOrderItem(order) {
                const downloadOrderBag = `${process.env.VUE_APP_PHOTOFIXRAPIHOST}/api/v1/photofixr/jobs/` + this.id + '/orders/' + order.id + '/DownloadCompleted'
                this.downloadLink(event, downloadOrderBag)
            },
            downloadJobBag() {
                const download = `${process.env.VUE_APP_PHOTOFIXRAPIHOST}/api/v1/photofixr/jobs/` + this.id + '/download'
                this.downloadLink(event, download)
                event.stopPropagation();
            },
            downloadCompleteOrders() {
                const downloadComplete = `${process.env.VUE_APP_PHOTOFIXRAPIHOST}/api/v1/photofixr/jobs/` + this.id + '/DownloadCompleted'
                this.downloadLink(event, downloadComplete)
                event.stopPropagation();
            },
            stopPropagation() {
                event.stopPropagation();
            }
        }
    };
</script>